module.exports = __webpack_public_path__ + "img/share-o.096d8bd9.png";